import React from 'react';
import Grid2 from '@mui/material/Unstable_Grid2';

export const PvGrid = React.forwardRef((props, ref) => <Grid2 {...props} forwardedRef={ref} />);
